export default __webpack_public_path__ + "50aaee0a9f4fdb321716933bb0d70aed.png";